import {useEffect, useRef} from 'react';

import {useOverlayScrollbars} from 'overlayscrollbars-react';


import {getDefaultOptions} from '../utils/get-default-options';

import type {Options} from '../utils/get-default-options';
import type React from 'react';

export const useSyncedScrollContainers = (options?: Options): {
    ref: React.RefObject<HTMLDivElement | null>,
    ref2: React.RefObject<HTMLDivElement | null>,
} => {
    const ref = useRef<HTMLDivElement>(null);
    const ref2 = useRef<HTMLDivElement>(null);
    const [initialize, instance] = useOverlayScrollbars({
        events: {
            scroll: self => {
                const {scrollLeft, scrollTop} = self.elements().viewport;
                instance2()?.elements().viewport.scrollTo({
                    top: scrollTop,
                    left: scrollLeft,
                    behavior: 'instant',
                });
            },
        },
        options: getDefaultOptions(options),
    });
    const [initialize2, instance2] = useOverlayScrollbars({
        events: {
            scroll: self => {
                const {scrollLeft, scrollTop} = self.elements().viewport;
                instance()?.elements().viewport.scrollTo({
                    top: scrollTop,
                    left: scrollLeft,
                    behavior: 'instant',
                });
            },
        },
        options: getDefaultOptions(options),
    });

    useEffect(() => {
        if (!ref.current) {
            return;
        }
        initialize(ref.current);
        return () => {
            instance()?.destroy();
        };
    }, [initialize, instance]);

    useEffect(() => {
        if (!ref2.current) {
            return;
        }
        initialize2(ref2.current);
        return () => {
            instance2()?.destroy();
        };
    }, [initialize2, instance2]);

    return {
        ref,
        ref2,
    };
};
